import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["files", "embed", "json", "query"];
import React, { useEffect, useState } from 'react';
import { getParameters } from 'codesandbox-import-utils/lib/api/define';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function request(files) {
  return fetch('https://codesandbox.io/api/v1/sandboxes/define?json=1', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify({
      files: files
    })
  }).then(x => x.json());
}
var CodeSandbox = props => {
  var _ref = props || {},
    {
      files = {},
      embed,
      json,
      query
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  var parameters = getParameters({
    files
  });
  var [url, setUrl] = useState();
  useEffect(() => {
    if (!props.children) {
      request(files).then(data => {
        if (data && data.sandbox_id) {
          var cusUrl = "https://codesandbox.io/" + (embed ? 'embed' : 's') + "/" + data.sandbox_id + "?" + (query ? query : '');
          setUrl(cusUrl);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files]);
  if (!props.children) {
    return /*#__PURE__*/_jsx("iframe", _extends({}, other, {
      title: other.title || 'Example.',
      src: url,
      style: _extends({
        width: '100%',
        height: '100%',
        border: 0,
        overflow: 'hidden'
      }, other.style),
      allow: "accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking",
      sandbox: "allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
    }));
  }
  return /*#__PURE__*/_jsxs("form", _extends({
    action: "https://codesandbox.io/api/v1/sandboxes/define",
    method: "POST",
    target: "_blank"
  }, other, {
    children: [/*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: "parameters",
      value: parameters
    }), embed && /*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: "embed",
      value: 1
    }), json && /*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: "json",
      value: 1
    }), query && /*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: "query",
      value: query
    }), /*#__PURE__*/_jsx("button", {
      type: "submit",
      children: props.children
    })]
  }));
};
export default CodeSandbox;